import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  getComboPDPDetails,
  notifyUser,
} from 'hb-redux-store/feature/products/product.action';
import Button from 'components/common/Button/Button';

import ButtonCounter from 'components/common/Button/ButtonCounter';
import USP from 'components/web/USP/USP';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import { resetPDP } from 'hb-redux-store/feature/products/product.action';
import {
  postAddItem,
  postRemoveItem,
} from 'hb-redux-store/feature/cart/cart.action';
import { setAppNotification } from 'hb-redux-store/initial.action';
import Messages from 'components/mweb/Messages/Messages';
// import { getCPMapping } from '../../../CPMapping';
import Icon from 'components/mweb/Icon/Icon';
// import ImageOverlay from '../../common/ImageOverlay/ImageOverlay';
import { Helmet } from 'react-helmet';
import Footer from './../../web-feature/footer/index';
import PDPCarousel from '../../common/PDPCarousel/PDPCarousel';
import Modal from '../../mweb/Modal/Modal';
import { setPreorderModal } from 'hb-redux-store/feature/modal/modal.action';
import Reviews from '../../common/Reviews/Reviews';
import ComboItems from '../../common/ComboProducts/ComboItem';
import moment from 'moment';
import { getDiscountText } from '../../../hb-redux-store/util/miscellaneousServices';
import HighLightTags from '../../mweb/HighlightTags/HighlightTags';

class ComboPDP extends React.Component {
  constructor(props) {
    super(props);
    this.comboProductId = this.props.match.params.comboProductId;
    this.attrLimit = 3;
    this.state = {
      currentSku: null,
      topAttrs: null,
      opInProgress: false,
      showImageModal: false,
    };
  }

  checkOffset = () => {
    let scrollTop =
      window.pageYOffset ||
      (document.documentElement || document.body.parentNode || document.body)
        .scrollTop;
    const outerDivCondition =
        document.getElementsByClassName('desktop-pdp--column-left') &&
        document.getElementsByClassName('desktop-pdp--column-left')[0],
      innerDivCondition =
        document.getElementsByClassName('desktop-pdp--column-right') &&
        document.getElementsByClassName('desktop-pdp--column-right')[0] &&
        document.getElementsByClassName('desktop-pdp--column-right')[0]
          .firstChild;
    if (
      outerDivCondition &&
      document.getElementsByClassName('desktop-pdp--column-left')[0]
        .scrollHeight -
        scrollTop <=
        265
    ) {
      if (innerDivCondition) {
        const topHeight =
          document.getElementsByClassName('desktop-pdp--column-left')[0]
            .scrollHeight - 265;

        document.getElementsByClassName(
          'desktop-pdp--column-right'
        )[0].firstChild.style.position = 'absolute';
        //scroll after certain height
        document.getElementsByClassName(
          'desktop-pdp--column-right'
        )[0].firstChild.style.top = `${topHeight}px`;
      }
    } else if (innerDivCondition) {
      document.getElementsByClassName(
        'desktop-pdp--column-right'
      )[0].firstChild.style.position = 'fixed';
      document.getElementsByClassName(
        'desktop-pdp--column-right'
      )[0].firstChild.style.top = '';
    }
  };

  componentDidMount() {
    this.props.getComboPDPDetails(this.comboProductId);
  }

  componentDidUpdate() {
    document.addEventListener('scroll', this.checkOffset);
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (!this.props.pdpDetails && nextProps.pdpDetails) {
      const skus = nextProps.pdpDetails.skus;
      const currentSku = skus[0];
      currentSku.discountText = getDiscountText({
        product: nextProps.pdpDetails,
        isProduct: true,
      });
      const topAttrs =
        currentSku?.skuAttributes?.filter(attr => attr.showTop) || [];
      this.setState({ currentSku, topAttrs, skus });
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    this.props.resetPDP();
    document.removeEventListener('scroll', this.checkOffset);
  }

  successOpCb = msg => ({ skuCount }) => {
    const newProduct = { ...this.state.product, inCartQuantity: skuCount };
    const skus = this.state.skus.map(s => ({ ...s }));
    skus[0].inCartQuantity = skuCount;
    this.props.setAppNotification(msg);
    this.setState({
      product: newProduct,
      skus,
      sku: skus[0],
      opInProgress: false,
    });
  };
  failOpCb = msg => ({ errorMessage = msg }) => {
    if (errorMessage !== 'Please select a location.')
      this.props.setAppNotification(errorMessage);
    this.setState({ opInProgress: false });
  };

  addItem = () => {
    const { salePrice, retailPrice, comboName } = this.props?.pdpDetails;
    this.setState({ opInProgress: true }, () => {
      this.props.postAddItem({
        comboProductId: this.comboProductId,
        productName: comboName,
        price: salePrice ?? retailPrice,
        quantity: 1,
        source: 'Combo PDP',
        successOpCb: this.successOpCb('Item added to cart'),
        failOpCb: this.failOpCb('Error adding item to cart'),
      });
    });
  };

  removeItem = () => {
    const { salePrice, retailPrice, comboName } = this.props?.pdpDetails;
    this.setState({ opInProgress: true }, () => {
      this.props.postRemoveItem({
        comboProductId: this.comboProductId,
        productName: comboName,
        price: salePrice ?? retailPrice,
        quantity: 1,
        source: 'Combo PDP',
        successOpCb: this.successOpCb('Item removed from cart'),
        failOpCb: this.failOpCb('Error removing item to cart'),
      });
    });
  };
  zoomImage = () => this.setState({ showImageModal: true });
  notify = () => {
    this.props.notifyUser({ sku: 'COMBO-' + this.comboProductId });
  };

  getContent = sku => (
    <div>
      <span>
        Date of Delivery: {moment(sku?.deliveryEndDate).format('DD MMMM YYYY')}
      </span>
      <br />
      <span>
        {`Will arrive in ${moment(sku?.deliveryEndDate).diff(
          moment(),
          'days'
        )} day(s)`}
      </span>
    </div>
  );

  render() {
    const { loadingPdp, pdpDetails, categorySeoName } = this.props;
    const { skus, topAttrs, showImageModal } = this.state;
    const [currentSku] = skus || [{}];
    const seo = {
      pageTitle: `Buy ${pdpDetails?.productName} ${categorySeoName} Online | Fresh Early Morning Delivery - VegXL`,
      keywords: `buy ${pdpDetails?.productName} ${categorySeoName} online`,
      canonicalUrl: `${window.location.origin}/${categorySeoName}/${this.props.productSeoName}`,
      pdpAltText: `Buy Fresh ${pdpDetails?.productName} online`,
      footerH1Text: `Buy Fresh ${pdpDetails?.productName} online`,
    };
    let primaryImage, images;
    if (pdpDetails) {
      primaryImage = pdpDetails.images.find(img => img.isPrimary).url;
      images = pdpDetails.images
        .filter(img => !img.isPrimary)
        .map(img => img.url);
      if (!images.length) images = [primaryImage];
      // images = [
      //   'https://ik.imagekit.io/iwcam3r8ka/products/202008/816c95cd-1bab-4efa-a398-87b6db41a32a.jpg',
      //   'https://ik.imagekit.io/iwcam3r8ka/prod/products/202007/dce0be5a-3ba1-426a-8841-e2a881a678d6.jpg',
      //   'https://ik.imagekit.io/iwcam3r8ka/products/202005/f71c73d0-cb17-4a66-9406-104b9f02b360.jpg',
      //   'https://ik.imagekit.io/iwcam3r8ka/products/202008/d5fa94dc-d1eb-4586-ad31-2465303d28af.jpg'
      // ];
      const seoMap = pdpDetails?.productSeoMapping || {};
      seo.pageTitle = seoMap.pageTitle || seo.pageTitle;
      seo.description = seoMap?.description || pdpDetails?.description;
      seo.keywords = seoMap?.keywords || seo?.keywords;
      seo.canonicalUrl = seoMap?.canonicalUrl || seo?.canonicalUrl;
      seo.pdpAltText = seoMap?.pdpAltText || seo?.pdpAltText;
    }
    const presaleMessage = 'This item is for pre order';
    const onSale = currentSku?.salePrice < currentSku?.retailPrice;
    return (
      <Fragment>
        <div className="desktop-pdp">
          {/* <SecondaryNav /> */}
          {loadingPdp && <Loader />}
          {!loadingPdp && pdpDetails && (
            <React.Fragment>
              <Helmet>
                <title>{seo.pageTitle}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <link rel="canonical" href={seo.canonicalUrl} />
                {/*  Twitter Card data  */}
                <meta name="twitter:card" value={seo.description} />
                {/*  Open Graph data  */}
                <meta property="og:title" content={seo.pageTitle} />
                <meta property="og:image" content={primaryImage} />
                <meta property="og:description" content={seo.description} />
              </Helmet>
              <div className="desktop-pdp--row">
                <div className="desktop-pdp--column desktop-pdp--column-left">
                  <div className="desktop-pdp--banner-image">
                    <PDPCarousel
                      images={images}
                      soldOut={!currentSku.isInventoryAvailable}
                      desktop
                      altText={seo.pdpAltText}
                    />
                    {!currentSku.isInventoryAvailable && (
                      <div className="desktop-pdp--banner-image--sold-out-tag">
                        <span className="text">OUT OF STOCK</span>
                      </div>
                    )}
                    <div
                      className="desktop-pdp--banner-image--zoom-icon"
                      onClick={this.zoomImage}
                    >
                      <Icon class="icon-common-zoom-lens" size={50} />
                    </div>
                  </div>
                  <div className="desktop-pdp--description">
                    <div className="desktop-pdp--description--title">
                      Description
                    </div>
                    <div className="desktop-pdp--description--content">
                      {pdpDetails.description}
                    </div>
                    <USP pageType={'ProductDescription'} />
                  </div>
                </div>
                <div className="desktop-pdp--column desktop-pdp--column-right">
                  <div className="desktop-pdp--column-right-child ">
                    <div
                      className={`desktop-pdp--main-details ${
                        pdpDetails.isBestSeller ? 'bestseller-tag' : ''
                      }`}
                    >
                      {pdpDetails.isBestSeller && (
                        <HighLightTags type="bestseller" source="pdp-desktop" />
                      )}
                      <ul className="desktop-pdp--main-details--ul justify-content--space-between">
                        <li className="desktop-pdp--main-details--li">
                          <div className="desktop-pdp--main-details--name">
                            {pdpDetails.productName}
                          </div>
                          <div className="desktop-pdp--main-details--weight">
                            {currentSku.quantity}
                          </div>
                        </li>
                        <li className="desktop-pdp--main-details--li">
                          <span
                            className={`desktop-pdp--main-details--retail-price ${
                              onSale ? 'on-sale' : ''
                            }`}
                          >
                            &#8377;{currentSku.retailPrice}
                          </span>
                          {onSale && (
                            <span className="desktop-pdp--main-details--sale-price">
                              &#8377;{currentSku.salePrice}
                            </span>
                          )}
                          {currentSku.discountText && (
                            <span className="desktop-pdp--main-details--sale-tag">
                              <Icon size={18} class="icon-cart-on-sale" />
                              {currentSku.discountText}
                            </span>
                          )}
                        </li>
                      </ul>
                      <ul className="desktop-pdp--main-details--ul justify-content--space-between">
                        <li className="desktop-pdp--main-details--li">
                          {/* <Dropdown /> */}
                        </li>
                        <li className="desktop-pdp--main-details--li">
                          <div>
                            {!currentSku.isInventoryAvailable && (
                              <Button
                                className="button action-link desktop-pdp--main-details--notify-me cursor-hover"
                                onClick={this.notify}
                              >
                                Notify Me
                              </Button>
                            )}
                            {currentSku.isInventoryAvailable &&
                              currentSku.inCartQuantity === 0 && (
                                <Button
                                  className="button button-ghost"
                                  disabled={this.state.opInProgress}
                                  onClick={this.addItem}
                                >
                                  ADD
                                </Button>
                              )}
                            {currentSku.isInventoryAvailable &&
                              currentSku.inCartQuantity > 0 && (
                                <ButtonCounter
                                  onIncrement={this.addItem}
                                  onDecrement={this.removeItem}
                                  className="button-counter-ghost"
                                  counter={currentSku.inCartQuantity}
                                  disabled={this.state.opInProgress}
                                />
                              )}
                          </div>
                        </li>
                      </ul>
                      {currentSku.isPresale && (
                        <div className="desktop-pdp--main-details--presale-nudge">
                          <Messages
                            type="pre-order"
                            message={presaleMessage}
                            actionable={true}
                            actionText={
                              <Button className="button action-link know-more cursor-hover">
                                Know More
                              </Button>
                            }
                            onAction={() =>
                              this.props.setPreorderModal({
                                visible: true,
                                title: pdpDetails.productName,
                                content: this.getContent(currentSku),
                              })
                            }
                          />
                        </div>
                      )}
                      <div className="section-divider" />
                      <ComboItems
                        items={pdpDetails.productSet}
                        title="Items in this combo"
                      />
                    </div>
                    {topAttrs.length > 0 && (
                      <div className="desktop-pdp--top-attribute">
                        {topAttrs.map((attr, index) => {
                          if (index < this.attrLimit) {
                            return (
                              <React.Fragment key={index}>
                                {index !== 0 && (
                                  <div className="desktop-pdp--top-attribute--divider"></div>
                                )}
                                <div className="desktop-pdp--top-attribute--attr">
                                  <div className="desktop-pdp--top-attribute--attr--key">
                                    {attr.displayName}
                                  </div>
                                  <div className="desktop-pdp--top-attribute--attr--value">
                                    {attr.value}
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          }
                        })}
                      </div>
                    )}
                    {/*<div className="desktop-pdp--combo-items">*/}
                    {/*  <ComboItems items={pdpDetails.products} title="Items in this combo"/>*/}
                    {/*  /!*{pdpDetails.products.map(p => <ProductCard product={p} shipment />)}*!/*/}
                    {/*</div>*/}
                  </div>
                </div>
              </div>
              {showImageModal && (
                <Modal
                  visible={showImageModal}
                  closable={false}
                  maskClosable={true}
                  wrapClassName="desktop-pdp--zoom-modal"
                  onCancel={() => this.setState({ showImageModal: false })}
                  maskStyle={{ background: 'rgba(0, 0, 0, 1)' }}
                >
                  <Icon
                    class="icon-common-close-white desktop-pdp--zoom-modal--close-icon"
                    size={30}
                    onClick={() => this.setState({ showImageModal: false })}
                  />
                  <PDPCarousel
                    desktop
                    images={images}
                    indicatorClassName="desktop-pdp--zoom-modal--indicator"
                    imageClassName="desktop-pdp--zoom-modal--fs-image"
                    altText={seo.pdpAltText}
                    // activeIndex={this.state.activeImageIndex}
                    // afterSwipe={i => this.setState({ activeImageIndex: i })}
                  />
                </Modal>
              )}
              <div className="section-divider" />
              <Reviews />
              <div>
                <Footer pdp h1={seo.footerH1Text} />
              </div>
            </React.Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ productReducer }) => {
  const { loadingPdp, pdpDetails } = productReducer;
  return {
    loadingPdp,
    pdpDetails,
  };
};

const mapDispatchToProps = {
  getComboPDPDetails,
  resetPDP,
  postAddItem,
  postRemoveItem,
  setPreorderModal,
  setAppNotification,
  notifyUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(ComboPDP);
